import { WindowWrapper } from 'cbioportal-frontend-commons';

export default new WindowWrapper();
